import { string } from '@iwentsourcing/core/typing/string.js';
import { boolean } from '@iwentsourcing/core/typing/boolean.js';
import { date } from '@iwentsourcing/core/typing/date.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareState } from '@iwentsourcing/core/storage/declare-state.js';
import { defineState } from '@iwentsourcing/core/storage/define-state.js';

export const Todo = declareState(
  'todos',
  {
    id: string(),
    title: string(),
    completed: boolean(),
    createdAt: date(),
  },
  ['id'] as const,
).index('date', ['createdAt']);

export type Todo = TypeOfEvent<typeof Todo>;

export const todoState = defineState([Todo]);

export type TodoState = typeof todoState;
